import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	clearFilterButtonLabel: {
		id: 'search-page.common.ui.clear-filter-button.label',
		defaultMessage: 'Clear filter',
		description: 'Label for button to clear filter options',
	},
});
